export default function () {
    return {
        rentals: []

    }
}


